import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    root: {
      display: "flex",
      justifyContent: "space-between",
      gap: "24px",
    },
    header: {
      marginBottom: "12px",
      padding: "5px",
      [theme.breakpoints.down('xs')]: {
        width: "50rem",
      },
    },
    scrollArrows: {
      display: "flex",
      gap: "16px",
      justifyContent: "flex-end",
      marginTop: "24px",
    },
  };
});
